import MonstersClanPreSale from '../contracts/MonstersClanPreSale.json';
import MonstersClanNftSale from '../contracts/MonstersClanNftSale.json';
import MonstersClanToken from '../contracts/MonstersClanToken.json';
import MonstersClanNft from '../contracts/MonstersClanNft.json';
import Staking from '../contracts/Staking.json';
import NftStaking from '../contracts/NftStaking.json';
import BinanceSwap from '../contracts/BinanceSwap.json';
import BinanceMysteryBox from '../contracts/BinanceMysteryBox.json';
import SaleModule from '../contracts/SaleModule.json';
import OfferModule from '../contracts/OfferModule.json';
import AuctionModule from '../contracts/AuctionModule.json';
import { getWeb3IfAvailable } from '../web3Utils';

export const getContractABI = (contractType) => {
    switch(contractType) {
        case 'MonstersClanPreSale':
            return MonstersClanPreSale.abi;
        case 'MonstersClanNftSale':
            return MonstersClanNftSale.abi;
        case 'MonstersClanToken':
            return MonstersClanToken.abi;
        case 'MonstersClanNft':
            return MonstersClanNft.abi;
        case 'NftStaking':
            return NftStaking.abi;
        case 'Staking':
            return Staking.abi;
        case 'BinanceSwap':
            return BinanceSwap.abi;
        case 'BinanceMysteryBox':
            return BinanceMysteryBox.abi;
        case 'SaleModule':
            return SaleModule.abi;
        case 'OfferModule':
            return OfferModule.abi;
        case 'AuctionModule':
            return AuctionModule.abi;
        default:
            return '';
    }
}

export const getContractAddress = async (contractType) => {
    const web3 = await getWeb3IfAvailable();
    const networkId = await web3.eth.net.getId();

    switch(contractType) {

        case 'MonstersClanPreSale':
            return MonstersClanPreSale.networks[networkId] ? MonstersClanPreSale.networks[networkId].address : '';
        case 'MonstersClanNftSale':
            return MonstersClanNftSale.networks[networkId] ? MonstersClanNftSale.networks[networkId].address : '';
        case 'MonstersClanToken':
            return MonstersClanToken.networks[networkId] ? MonstersClanToken.networks[networkId].address : '';
        case 'MonstersClanNft':
            return MonstersClanNft.networks[networkId] ? MonstersClanNft.networks[networkId].address : '';
        case 'NftStaking':
            return NftStaking.networks[networkId] ? NftStaking.networks[networkId].address : '';
        case 'Staking':
            return Staking.networks[networkId] ? Staking.networks[networkId].address : '';
        case 'BinanceSwap':
            return BinanceSwap.networks[networkId] ? BinanceSwap.networks[networkId].address : '';
        case 'BinanceMysteryBox':
            return BinanceMysteryBox.networks[networkId] ? BinanceMysteryBox.networks[networkId].address : '';
        case 'SaleModule':
            return SaleModule.networks[networkId] ? SaleModule.networks[networkId].address : '';
        case 'OfferModule':
            return OfferModule.networks[networkId] ? OfferModule.networks[networkId].address : '';
        case 'AuctionModule':
            return AuctionModule.networks[networkId] ? AuctionModule.networks[networkId].address : '';
        default:
            return ''
    }
}